import { FC } from 'react';
import './loader.scss';

type DotLoaderProps = {
  text?: string;
};

const DotLoader: FC<DotLoaderProps> = ({ text }) => {
  return (
    <div className="dot-loader">
      <div className="overlay">
        <div className="loader-container">
          <div className="dot-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
          {text && (
            <div className="loader-text-container">
              <p className="loader-text">{text}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DotLoader;
